<div class="wrapper" [ngClass]="{ 'bg-transparent': transparentBackground }">
  <div class="scrollbar">
    <div
      *ngIf="hasHorizontalArrows"
      class="arrow"
      [ngClass]="{ 'arrow-left': !isRtl, 'arrow-right': isRtl }"
      (touchstart)="onArrowDown($event, true)"
      (touchend)="onArrowUp($event)"
      (mousedown)="onArrowDown($event, true)"
      (mouseup)="onArrowUp($event)"
    >
      <shrd-uic-svg-icon icon="arrow-left" [preventRtlSwap]="true" size="small"></shrd-uic-svg-icon>
    </div>
    <div
      #track
      class="track"
      [ngClass]="{ 'no-arrow': !hasHorizontalArrows }"
      (touchstart)="onTrackDown($event)"
      (mousedown)="onTrackDown($event)"
    >
      <div
        #thumb
        class="thumb"
        cdkDrag
        [cdkDragLockAxis]="horizontal ? 'x' : 'y'"
        [cdkDragBoundary]="track"
        [cdkDragFreeDragPosition]="position"
        (cdkDragMoved)="onMoving()"
        (cdkDragReleased)="onMoveEnd()"
        (touchstart)="$event.stopPropagation()"
        (mousedown)="$event.stopPropagation()"
        [style.height.px]="thumbSize.height"
        [style.width.px]="thumbSize.width"
      ></div>
    </div>
    <div
      *ngIf="hasHorizontalArrows"
      class="arrow"
      [ngClass]="{ 'arrow-left': isRtl, 'arrow-right': !isRtl }"
      (touchstart)="onArrowDown($event)"
      (touchend)="onArrowUp($event)"
      (mousedown)="onArrowDown($event)"
      (mouseup)="onArrowUp($event)"
    >
      <shrd-uic-svg-icon icon="arrow-right" [preventRtlSwap]="true" size="small"></shrd-uic-svg-icon>
    </div>
  </div>
</div>
